<template>
  <div class="main-content">
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "app",
};
</script>
